import { get } from 'svelte/store';
import { storeBackendUrl, storeAccessToken, storeError } from '../store';
import { storePodcasts, storePodcast, emptyPodcast } from '../classes/podcast';
import { authentication } from './api';
/**
 * getPodcasts
 * /podcasts/ - GET
 */
export async function getPodcasts() {
    const apiUrl = get(storeBackendUrl) + "v1/podcasts/";
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(storeAccessToken));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storePodcasts.set(data);
        storeError.set("");
        return true;
    })
        .catch((error) => {
        const emptyPodcasts = new Array(emptyPodcast);
        storePodcasts.set(emptyPodcasts);
        storeError.set(error);
        return false;
    });
}
/**
 * getPodcast
 * /podcasts/ - GET
 */
export async function getPodcast(id) {
    const apiUrl = get(storeBackendUrl) + "v1/podcasts/?id=" + id;
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(storeAccessToken));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storePodcast.set(data);
        storeError.set("");
        return true;
    })
        .catch((error) => {
        storePodcast.set(emptyPodcast);
        storeError.set(error);
        return false;
    });
}
